import { connect } from 'react-redux';

import * as lightboxActions from '../lightbox/actions';

import FrontPageComponent from './FrontPageComponent';

const mapStateToProps = ({ lightbox }) => ({
  frontPageImage: lightbox.frontPageImage,
  images: lightbox.images,
  isOpen: lightbox.isOpen,
  currentImageIndex: lightbox.currentImageIndex,
  image: lightbox.images && lightbox.images[0],
});

const mapDispatchToProps = dispatch => ({
  lightbox: {
    open: () => dispatch(lightboxActions.open),
    close: () => dispatch(lightboxActions.close),
    next: () => dispatch(lightboxActions.next),
    prev: () => dispatch(lightboxActions.prev),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FrontPageComponent);



// WEBPACK FOOTER //
// ./src/pages/FrontPage.js